module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("Fallen Royals (Bad Boy Royals of Kingsbury Prep)")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c004"
    }
  }, [_vm._v("PLEASE READ BEFORE READING THIS BOOK")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get a Free Copy of Kailin Gow’s Full Book | Blue Room Vol.1 | When you Sign Up for Rachel Angel and Kailin Gow’s  New Releases Newsletter!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heartbreak Falls Series")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Excerpt | DIAMONDS AND DRAGONS | Now Available")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Want to read more? | Diamonds and Dragons is Now Available on KU")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Diamonds and Dragons")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roses and Emeralds")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Silver and Starlight")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("OTHER REVERSE HAREM or RH BULLY ROMANCE BOOKS NOW AVAILABLE OR FOR PRE-ORDER | FALLEN FAE ACADEMY | Series Blurb")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Initiation:  Year 1")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Transformation:  Year 2")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Declaration: Year 3")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shadowlight Academy Series | The Beautiful Boys")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Magic Over Boys")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gone Rogue")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Shadowlight Hunters Academy Series")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SOCIETY OF SUPERNATURAL SLEUTHS")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("SCARLET’S THREE")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IMMORTAL MAGIC")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("FAE AND FANGS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0